module.exports = __webpack_public_path__ + "static/media/students.8cdc6e68.png";